import store from '@/config/vuex'
import { toRetry } from '@/helpers/request'
import dyEventHandlers, { DYNAMIC_YIELD } from './dynamic-yield/dy-events'
import gtmEventHandlers, { GTM } from './gtm/gtm-events'

export const ACTIONS = {
  addToCart: 'add-to-cart',
  campaignClick: 'campaign-click',
  campaignView: 'campaign-view',
  checkout: 'checkout',
  errors: 'errors',
  filterAndSorting: 'filter-and-sorting',
  listClick: 'list-click',
  listView: 'list-view',
  navigation: 'navigation',
  notification: 'notification',
  option: 'option',
  pdpTopGalleryExperiment: 'pdp-top-gallery-experiment',
  productInteraction: 'product-interaction',
  productView: 'product-view',
  promotionClick: 'promotion-click',
  promotionView: 'promotion-view',
  purchase: 'purchase',
  quiz: 'quiz',
  removeFromCart: 'remove-from-cart',
  shoeComparison: 'shoe-comparison',
  shoeFinder: 'shoe-finder',
  shoeMatcher: 'shoe-matcher',
  sizeGuide: 'size-guide',
  sizeInfo: 'size-info',
  subscriptions: 'subscriptions',
  survey: 'survey',
  userAccount: 'user-account',
  virtPath: 'virt-path',
}

export const CONTEXTS = {
  navigationTeaser: 'navigation teaser',
  promoCard: 'promo card',
  search: 'search results',
  recommendation: 'recommendation',
  shoeFinder: 'shoe finder',
  shoeComparison: 'shoe comparison',
}

async function dispatchExternalEvents(payload) {
  const eventHandlers = {
    [DYNAMIC_YIELD]: dyEventHandlers,
    [GTM]: gtmEventHandlers,
  }
  const filename = payload.action
  const [error, response] = await toRetry(() =>
    import(/* webpackChunkName: "[request]" */ `./_actions/${filename}`)
  )
  if (!error) {
    const actions = response.default
    Object.keys(actions).forEach(externalService => {
      Object.keys(actions[externalService]).forEach(action => {
        const eventPayload = actions[externalService][action](payload, store)
        eventHandlers[externalService][action](action, eventPayload)
      })
    })
  }
}

export const notifyExternalServices = payload => {
  dispatchExternalEvents(payload)
  // other things than events can also be dispatched here...
}

export const ExternalCommunicationPlugin = {
  install(Vue) {
    Vue.prototype.$notifier = {
      ACTIONS,
      CONTEXTS,
      trackEvent: notifyExternalServices,
    }
  },
}

window.On = window.On || {}
On.notifyExternalServices = notifyExternalServices
On.EXTERNAL_SERVICES_ACTIONS = ACTIONS
